import React, { Fragment } from 'react';
import DineInIcon from '../../../../assets/images/Orders/ordersdinein.png';
import { Image, Row, Form, Col } from 'react-bootstrap';

function OrderSettings({ formik, expType, count, ...props }) {
  const orderTypes = [
    {
      id: 0,
      title: 'Takeaway',
      show: true,
      image: require('../../../../assets/images/seatingImages/takeawayicon.svg'),
      value: '',
    },
    {
      id: 1,
      title: 'Curb-side',
      show: true,
      image: require('../../../../assets/images/seatingImages/curbsideicon.svg'),
      value: '',
    },
    {
      id: 3,
      title: 'Dine-In',
      show: true,
      image: DineInIcon,
      value: 'DINEIN',
    },
    {
      id: 2,
      title: 'Skip-The Line',
      show: true,
      image: require('../../../../assets/images/superadmin/ordericon/skipTheLine.svg'),
      value: '',
    },
    {
      id: 4,
      title: 'Buffet',
      show: false,
      image: require('../../../../assets/images/Orders/Buffet.svg'),
      value: '',
    },
    {
      id: 7,
      title: 'Delivery',
      show: true,
      image: require('../../../../assets/images/superadmin/ordericon/delivery.svg'),
      value: 'DELIVERY',
    },
    {
      id: 6,
      title: 'Drive Thru',
      show: false,
      image: require('../../../../assets/images/Orders/Drive thru.svg'),
      value: '',
    },
    {
      id: 9,
      title: 'Catering',
      show: false,
      image: require('../../../../assets/images/Orders/catering.svg'),
      value: '',
    },
  ];

  const handleOrderTypeSelection = (value) => {
    let updatedOrderTypes = [...formik.values.orderType];
    if (updatedOrderTypes.includes(value)) {
      updatedOrderTypes = updatedOrderTypes.filter((type) => type !== value);
    } else {
      if (value === 'DINEIN' || value === 'DELIVERY') {
        updatedOrderTypes.push(value);
      }
    }
    formik.setFieldValue('orderType', updatedOrderTypes);
  };

  console.log(formik.values.orderType);

  return (
    <>
      <div className="f18-700">Order Type</div>
      <div className="f12-500 my-2">
        Select in which all order types menu is available.
      </div>
      <div className="my-2">
        <Row className="pt-3" style={{ width: '70%' }}>
          {orderTypes.map((data, index) => {
            const isSelected = formik.values.orderType.includes(data.value);
            return (
              <Fragment key={index}>
                {data.show &&
                (data.value === 'DINEIN' || data.value === 'DELIVERY') ? (
                  <>
                    <div
                      className="col-1 mb-1 text-center"
                      key={data.id}
                      onClick={() => handleOrderTypeSelection(data.value)}
                    >
                      <div
                        className={`d-flex align-items-center justify-content-center take-away-order-select ${
                          isSelected ? 'selected' : ''
                        }`}
                        style={{
                          borderRadius: '50px',
                          width: '55px',
                          height: '55px',
                          margin: '0 auto',
                          border: isSelected ? '2px solid #ee3a23' : 'none',
                        }}
                      >
                        <Image
                          src={data.image}
                          className="rounded-circle img-fluid"
                        />
                      </div>
                      <div className="mt-3 f10-500">{data.title}</div>
                    </div>
                  </>
                ) : (
                  <Fragment></Fragment>
                )}
              </Fragment>
            );
          })}
        </Row>
      </div>
      <Col md={6}>
        {formik.values.orderType.includes('DELIVERY') && (
          <Form.Group as={Row} className="mt-3">
            <Form.Label column sm={4} className="f18-700">
              Packaging Charges
            </Form.Label>
            <Col sm={6}>
              <Form.Control
                type="number"
                name="packagingCharges"
                value={formik.values.packaging_charges}
                onChange={formik.handleChange}
              />
            </Col>
          </Form.Group>
        )}
      </Col>
    </>
  );
}

export default OrderSettings;
